/* Sitenin kaynakları, panelin paketine metin olarak gömülü.

   Önizleme bunlarla çiziliyor (editor/page.ts): aynı şablonlar, aynı
   style.css, aynı betikler. Site değişince panel yeniden paketlendiğinde
   önizleme de değişiyor — elle eşlenecek ikinci bir kopya yok. */

import index from '../../../site/templates/index.html?raw';
import works from '../../../site/templates/works.html?raw';
import album from '../../../site/templates/album.html?raw';
import blog from '../../../site/templates/blog.html?raw';
import post from '../../../site/templates/post.html?raw';
import notFound from '../../../site/templates/404.html?raw';
import header from '../../../site/templates/partials/header.html?raw';
import menu from '../../../site/templates/partials/menu.html?raw';
import footer from '../../../site/templates/partials/footer.html?raw';
import lightbox from '../../../site/templates/partials/lightbox.html?raw';
import hero from '../../../site/templates/blocks/hero.html?raw';
import coverflow from '../../../site/templates/blocks/coverflow.html?raw';
import reels from '../../../site/templates/blocks/reels.html?raw';
import cardsAi from '../../../site/templates/blocks/cards-ai.html?raw';
import cardsService from '../../../site/templates/blocks/cards-service.html?raw';
import factsStats from '../../../site/templates/blocks/facts-stats.html?raw';
import split from '../../../site/templates/blocks/split.html?raw';
import cta from '../../../site/templates/blocks/cta.html?raw';
import contact from '../../../site/templates/blocks/contact.html?raw';
import siteHeader from '../../../site/templates/blocks/site-header.html?raw';
import siteMenu from '../../../site/templates/blocks/site-menu.html?raw';
import siteFooter from '../../../site/templates/blocks/site-footer.html?raw';
import pagecta from '../../../site/templates/blocks/pagecta.html?raw';
import styleCss from '../../../site/assets/css/style.css?raw';
import i18nJs from '../../../site/assets/js/i18n.js?raw';
import mainJs from '../../../site/assets/js/main.js?raw';

export const INDEX = index;
/** Sayfa şablonları — tools/src/pages.ts'in beklediği adlarla. */
export const PAGES: Record<string, string> = { index, works, album, blog, post, '404': notFound };
export const PARTIALS: Record<string, string> = { header, menu, footer, lightbox };
export const BLOCK_TEMPLATES: Record<string, string> = {
  hero,
  coverflow,
  reels,
  'cards-ai': cardsAi,
  'cards-service': cardsService,
  'facts-stats': factsStats,
  split,
  cta,
  contact,
  'site-header': siteHeader,
  'site-menu': siteMenu,
  'site-footer': siteFooter,
  pagecta
};
export const STYLE_CSS = styleCss;
export const I18N_JS = i18nJs;
export const MAIN_JS = mainJs;
